import { AppStateFacade } from '@app-state';
import { WidgetResource } from '@pages/monitoring/types';

import extendWith from 'lodash-es/extendWith';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

// Order is important, the keys will be checked in case the view permission is denied while on the page
export const PERMISSION_MAP: Record<WidgetResource, string> = {
    [WidgetResource.Robot]: 'Robots.View',
    [WidgetResource.Queue]: 'Queues.View',
    [WidgetResource.Job]: 'Jobs.View',
    [WidgetResource.QueueSla]: 'Queues.View',
};

export const resourceKeys = () =>
    Object.keys(PERMISSION_MAP) as WidgetResource[];

export const permissionMapFactory = (appState: AppStateFacade) => combineLatest([
    ...resourceKeys().map(
        (resource: WidgetResource) => appState.user.permissions
            .isGranted(PERMISSION_MAP[resource])
            .pipe(
                map(isGranted => ({
                    [resource]: isGranted,
                })),
            ),
    ),
]).pipe(
    map(permissions => extendWith({}, ...permissions) as Record<WidgetResource, boolean>),
);
